import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import Cart from "./images/cart.png";

class CartList extends Component {
  state = {
    cartClosed: false
  };

  handleFilterItems = (e, id) => {
    e.preventDefault();
    this.props.filterCartItems(id);
  };

  handleCart = e => {
    e.preventDefault();
    this.setState(prevState => ({ cartClosed: !prevState.cartClosed }));
  };

  mapCartItems = itemsData => {
    return itemsData.map((item, index) => {
      return (
        <div key={index} className="cartDetails">
          <img src={item.imgUrl} alt={item.title} width="80px" />

          <h2>
            {item.title}{" "}
            <span
              style={{ color: "red" }}
              onClick={e => this.handleFilterItems(e, item.cartId)}
              className="removeButton"
            >
              X
            </span>
          </h2>
          <p>
            {item.currencyFormat} {item.price}
          </p>
          <hr />
        </div>
      );
    });
  };

  getTotalAmount = itemsData => {
    let totalAmount;
    const sumAmount = (currentTotalAmount, order) =>
      currentTotalAmount + order.price;
    return (totalAmount = itemsData.reduce(sumAmount, 0));
  };

  render() {
    const { cartItems } = this.props;
    const { cartClosed } = this.state;
    return (
      <div className="cartContainer">
        <img src={Cart} alt="cart logo." onClick={this.handleCart} />
        <h2 className="totalItems">{cartItems.length}</h2>
        <div className={cartClosed ? "cartClosed" : "cartContent"}>
          {cartItems ? this.mapCartItems(cartItems) : null}
          {cartItems ? (
            <h2 className="totalAmount">
              Total: {this.getTotalAmount(cartItems)}
            </h2>
          ) : null}
        </div>
      </div>
    );
  }
}

CartList.propTypes = {
  cartItems: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  filterCartItems: PropTypes.func.isRequired
};

export default CartList;
